import React, { useState } from "react";

const TechStack = () => {
  const [active, setActive] = useState("Frontend");

  const techData = {
    Frontend: [
      { name: "React.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
      { name: "HTML5", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" },
      { name: "CSS3", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" },
      { name: "Tailwind", logo: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg" },
    ],
    Backend: [
      { name: "Node.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
      { name: "Express.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" },
      { name: "MongoDB", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" },
    ],
    Tools: [
      { name: "Git", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" },
      { name: "GitHub", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" },
      { name: "VS Code", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg" },
    ],
  };

  const items = techData[active];

  return (
    <section
      className={`py-28 relative overflow-hidden transition-all duration-700 ${
        active === "Frontend"
          ? "bg-gradient-to-r from-indigo-50 via-white to-red-50"
          : active === "Backend"
          ? "bg-gradient-to-r from-green-50 via-white to-emerald-100"
          : "bg-gradient-to-r from-yellow-50 via-white to-orange-100"
      }`}
    >

      <div
        className={`absolute -top-40 -left-40 w-[400px] h-[400px] rounded-full blur-3xl ${
          active === "Frontend"
            ? "bg-red-200/30"
            : active === "Backend"
            ? "bg-green-200/30"
            : "bg-yellow-200/30"
        }`}
      />

      <div
        className={`absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full blur-3xl ${
          active === "Frontend"
            ? "bg-indigo-200/30"
            : active === "Backend"
            ? "bg-emerald-200/30"
            : "bg-orange-200/30"
        }`}
      />

      <div className="text-center mb-14 relative z-10">
        <p className="text-red-600 font-semibold tracking-widest uppercase text-sm">
      Learn. Grow. Succeed.
        </p>

        <h2 className="mt-3 text-4xl md:text-5xl font-bold text-gray-900">
     Professional courses designed for real-world skills
        </h2>

        <div className="w-24 h-1 bg-red-600 mx-auto mt-4 rounded-full"></div>
      </div>

      <div className="flex justify-center gap-5 mb-12 flex-wrap relative z-10">
        {Object.keys(techData).map((key) => (
          <button
            key={key}
            onMouseEnter={() => setActive(key)}
            className={`px-8 py-3 rounded-full font-semibold shadow-md transition-all duration-300 ${
              active === key
                ? "bg-red-600 text-white scale-110"
                : "bg-white text-gray-700 hover:text-red-600"
            }`}
          >
            {key}
          </button>
        ))}
      </div>

      <div className="flex justify-center relative z-10">
        <div className="w-full max-w-6xl overflow-hidden px-4">

          <div className="flex gap-10 w-max animate-marquee">

            {[...items, ...items, ...items].map((tech, i) => (
              <div
                key={i}
                className="min-w-[220px] bg-white/80 backdrop-blur-md border border-gray-200 rounded-2xl shadow-md hover:shadow-2xl p-6 flex flex-col items-center justify-center transition hover:scale-105"
              >
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="w-14 h-14 mb-3 object-contain"
                />

                <h3 className="font-semibold text-gray-800">
                  {tech.name}
                </h3>
              </div>
            ))}

          </div>
        </div>
      </div>
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          .animate-marquee {
            animation: marquee 18s linear infinite;
          }

          .animate-marquee:hover {
            animation-play-state: paused;
          }
        `}
      </style>

    </section>
  );
};

export default TechStack;